// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_ieq","delete":"styles_delete__2Yk0w","update":"styles_update__34-bP","add":"styles_add__3Yg36"};